export enum BoardSeatRepresenting {
  RA_CAP = 'RA_CAP',
  INDIVIDUAL = 'INDIVIDUAL',
}

export const BoardSeatRepresentingLabels: Record<BoardSeatRepresenting, string> = {
  [BoardSeatRepresenting.RA_CAP]: 'RA Capital',
  [BoardSeatRepresenting.INDIVIDUAL]: 'Individual'
};
